import { createI18n } from 'vue-i18n';
import en from '@/lang/en.json';

const defaultLocale = 'en';

const messages = {
    en
};

const i18n = createI18n({
    legacy: false,
    locale: defaultLocale,
    fallbackLocale: 'en',
    messages
});

export default i18n;